/* unplugin-vue-components disabled */import script from "./app-download.vue?vue&type=script&setup=true&lang=js"
export * from "./app-download.vue?vue&type=script&setup=true&lang=js"

import "./app-download.vue?vue&type=style&index=0&id=2e9e72fe&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9e72fe"]])

export default __exports__